import { styled } from '@slal/ui';
import { breakpointUp } from '@slal/ui/helpers';

export const StyledCard = styled.div`
    padding: ${({ theme: { space } }) => space[6]} ${({ theme: { space } }) => space[5]};
    background: ${({ theme: { colors } }) => colors.neutral__light__00};
    min-height: auto;
    height: 100%;
    border-radius: 10px;
    border: 1px solid #c3d7e3;

    ${breakpointUp.md`
        max-width:400px
    `}
`;

export const StyledIconCard = styled(StyledCard)`
    display: flex;
    flex-direction: column;
    gap: 16px;

    ${breakpointUp.md`
        max-width:640px
    `}
`;

export const IconHeadingWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 8px;
    align-items: center;

    svg {
        flex-shrink: 0;
    }
`;

export const StyledValueCard = styled(StyledCard)`
    min-width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    text-align: center;

    ${breakpointUp.md`
        min-width: auto;
        max-width: 550px;
    `}

    h3 {
        font-size: 20px;
        font-weight: 700;
        line-height: 1.2;
    }

    h2 {
        font-weight: 700 !important;
        color: #147cb3;
        margin-bottom: 0 !important;
    }
`;
